import { ThemesDataResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { UsersEditControllerModule } from './controllers/UsersEditController';

export const UsersEditView = angular
  .module('acme.view.application.users.edit', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    UsersEditControllerModule,
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.users.edit',
      url: '/:id/edit',
      views: {
        'subview-main': {
          controller: 'UsersEditController',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/users/edit/edit.tpl.html',
        },
      },
      data: {
        pageTitle: 'Edit User',
        permissions: ['USERS_UPDATE'],
      },
      resolve: {
        ThemesData: ThemesDataResolver(),
      },
    });
  }).name;
